import { generate } from '@/utils/request';
const config = {
  prefix: '/spur/v1/{organizationId}/',
  items: [
    // 采购出库单列表
    { key: 'getStockouts', url: 'stockouts', method: 'GET' },
    // 创建采购出库单
    { key: 'addStockouts', url: 'stockouts', method: 'POST' },
    // 修改采购出库
    { key: 'putStockouts', url: 'stockouts', method: 'PUT' },
    // 删除采购出库单
    { key: 'deleteStockouts', url: 'stockouts/batch', method: 'DELETE' },
    // 采购出库单明细
    { key: 'getStockoutsDetail', url: 'stockouts/detail', method: 'GET' },
    // 反审核
    { key: 'antiAuditStockouts', url: 'stockouts/anti-audit', method: 'PATCH' },
    // 审核
    { key: 'auditStockouts', url: 'stockouts/audit', method: 'PATCH' },
    // 取消
    { key: 'cancelStockouts', url: 'stockouts/cancel', method: 'PATCH' },
    // 采购出库单导出
    { key: 'reportStockouts', url: 'stockouts/report', method: 'GET', rType: 2 },
  ],
};
export default {
  ...generate(config),
};
